import angular from 'angular'
import template from './template.html'

angular.module('nominas.catalogos')
  .component('nominasCatalogosSumario', {
    template: template,
    controller: NominasCatalogosSumarioComponent,
  });

function NominasCatalogosSumarioComponent($http) {
  let $ctrl = this;

  $ctrl.$onInit = $onInit;

  function $onInit() {
    $ctrl.promise = $http.get('api/nominas/catalogos', {
        schema: {
          conceptos: 'boolean',
        },
      })
      .then(function (response) {
        $ctrl.data = response.data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/catalogos/components/sumario/controller.js